import React from "react"
import { Link } from "gatsby";
import { Container, Row, Col } from 'react-bootstrap'
import CTAMenuLink from "../../../modules/cta_menu_link_module"
import { isAuthenticated, getUser } from "@starberry/myaccount-website-utils";
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter"
import {currency_converter} from "../../../common/constant"

const TopMenu = ({data, currency}) => {
  const authuser = isAuthenticated()

  const userData = getUser();

  //console.log("userData", userData)

  return (
    <>
    {data?.links?.length > 0 && 
      <div className="primary-header">
          <Container>
            <Row>
              <Col>
                <div className="top-header">
                  <ul>
                    {data?.links?.map((item, index) => {
                      return(
                        <li key={item}><CTAMenuLink item={item} /></li>
                      )
                    })}                  
                  </ul>

                  {currency_converter && (
                    <CurrencyConverter outterClass="d-flex align-items-center price-change" currency={currency} />
                  )}

                  {(process.env.GATSBY_MYACCOUNT_URL && !process.env.GATSBY_MYACCOUNT_CUSTOM) && (
                        <Link to={`${process.env.GATSBY_MYACCOUNT_URL}`} className="sb-myacc" aria-label="myaccount">
                          <i className="icon-author"></i> {authuser ? userData?.name : "Sign in" }
                        </Link>
                  )}

                  {process.env.GATSBY_MYACCOUNT_CUSTOM && 
                    <Link to={process.env.GATSBY_MYACCOUNT_CUSTOM} className="sb-myacc custom_myacc" aria-label="myaccount">
                      <i className="icon-author"></i> {authuser ? userData?.name : "Sign in" }
                    </Link>
                  }
                  </div>
              </Col>
            </Row>
          </Container>
      </div>
      }
    </>
  )
}



export default TopMenu